import React from 'react';

const GiftCardSVG = ({ width, height, fill, style }) => {
    const viewBoxValues = "0 -5 55 55";

    return (
        <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox={viewBoxValues} style={style}>
            <path fill={fill}  d="M7 34.15V39h34v-4.85ZM7 12h6.25q-.25-.45-.4-1.125-.15-.675-.15-1.225 0-2.35 1.65-4T18.3 4q1.55 0 2.85.775T23.2 6.75l.85 1.3.8-1.3q.8-1.25 2.05-2Q28.15 4 29.6 4q2.4 0 4.05 1.625T35.3 9.65q0 .55-.125 1.1T34.8 12H41q1.2 0 2.1.9.9.9.9 2.1v24q0 1.2-.9 2.1-.9.9-2.1.9H7q-1.2 0-2.1-.9Q4 40.2 4 39V15q0-1.2.9-2.1.9-.9 2.1-.9Zm0 16.8h34V15H28.55l5 6.95-2.4 1.8-7.15-9.9-7.15 9.9-2.4-1.8 5-6.95H7Zm11.35-16.5q1.1 0 1.875-.775Q21 10.75 21 9.65t-.775-1.875Q19.45 7 18.35 7t-1.875.775Q15.7 8.55 15.7 9.65t.775 1.875q.775.775 1.875.775Zm11.25 0q1.15 0 1.925-.775.775-.775.775-1.875t-.775-1.875Q30.75 7 29.6 7q-1.05 0-1.825.775Q27 8.55 27 9.65t.775 1.875q.775.775 1.825.775Z"/>
        </svg>
    )
}

export default GiftCardSVG;


// WEBPACK FOOTER //
// ./src/components/common/svgs/GiftCardSvg.js